<div class="d-flex align-items-center" mat-dialog-title>
    <div class="spacer title">Briefpapier toevoegen</div>
    <div>
        <button (click)="close()" mat-icon-button tabindex="-1"><i class="fas fa-times"></i></button>
    </div>
</div>

<div mat-dialog-content class="pdf-dialog-content">
    <div class="row g-4 align-items-start">
        <!-- Linkerkant (Desktop) / Midden (Mobiel): Kader & Marges Preview -->
        <div class="col-24 col-md-10 order-2 order-md-1">
            <div class="margin-preview-wrapper">
                <label class="form-label mb-2"><b>Document marges</b></label>

                <div class="margin-preview-container">
                    <div class="a4-sheet">
                        <div class="margin-top" [style.height.px]="topMarginBandHeight">
                            <span>{{ selectedOption?.marginTop ?? defaultMarginTop | number: '1.1-1' }} cm</span>
                        </div>

                        <div class="sheet-middle">
                            <div class="margin-side margin-left" [style.width.px]="leftMarginBandWidth">
                                <span>{{ selectedOption?.marginLeft ?? defaultMarginLeft | number: '1.1-1' }} cm</span>
                            </div>

                            <div class="document-body">
                                <div class="content-placeholder">
                                    <i class="fas fa-file-alt mb-1 text-muted"></i>
                                    <span>A4</span>
                                </div>
                            </div>

                            <div class="margin-side margin-right" [style.width.px]="rightMarginBandWidth">
                                <span
                                    >{{ selectedOption?.marginRight ?? defaultMarginRight | number: '1.1-1' }} cm</span
                                >
                            </div>
                        </div>

                        <div class="margin-bottom" [style.height.px]="bottomMarginBandHeight">
                            <span>{{ selectedOption?.marginBottom ?? defaultMarginBottom | number: '1.1-1' }} cm</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Rechterkant (Desktop) / Bovenkant (Mobiel): Controls (Upload & Selector) -->
        <div class="col-24 col-md-14 order-1 order-md-2">
            <div class="mb-3">
                <label class="form-label mb-1" for="paperTypeSelect"><b>Type briefpapier</b></label>
                <select id="paperTypeSelect" class="form-select" [formControl]="selectedPaperType">
                    @for (type of paperTypes; track type.key) {
                        <option [value]="type.key">
                            {{ type.label }}
                        </option>
                    }
                </select>
            </div>

            <div class="mb-3">
                <label class="form-label mb-1" for="pdfUpload"><b>PDF upload</b></label>
                <input
                    id="pdfUpload"
                    type="file"
                    accept="application/pdf"
                    class="form-control"
                    (change)="onFileInputChange($event)" />
            </div>

            <div class="d-none d-md-block">
                @if (errorMessage) {
                    <div class="alert alert-danger mb-0">{{ errorMessage }}</div>
                }

                @if (successMessage) {
                    <div class="alert alert-success mb-0">{{ successMessage }}</div>
                }
            </div>
        </div>

        <!-- Meldingen op mobiel (helemaal onderaan, onder het kader) -->
        <div class="col-24 order-3 d-md-none">
            @if (errorMessage) {
                <div class="alert alert-danger mb-0">{{ errorMessage }}</div>
            }

            @if (successMessage) {
                <div class="alert alert-success mb-0">{{ successMessage }}</div>
            }
        </div>
    </div>
</div>

<div class="buttons d-flex justify-content-between" mat-dialog-actions>
    <button class="planning-button cancel" (click)="close()" [disabled]="isProcessing" mat-button>Sluiten</button>
    <button
        class="planning-button confirm"
        [disabled]="!selectedFile || isProcessing"
        (click)="applyBackground()"
        color="primary"
        mat-raised-button>
        Toevoegen & downloaden
        @if (isProcessing) {
            <i class="fas fa-circle-notch fa-spin ms-1"></i>
        }
    </button>
</div>
